
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightEmergencyColourOn as ObiLightEmergencyColourOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-emergency-colour-on.js';
 
 
 

 
 export const ObiLightEmergencyColourOn = createComponent({
   react: React,
   tagName: 'obi-light-emergency-colour-on',
   elementClass: ObiLightEmergencyColourOnElement,
   events: {
     
   }
  });
 
 